import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { roleWrite } from "../../../../shared/constants/user-roles";
import AuthContext from "../../../../shared/context/auth-context";
import DataTable from "../../../components/data-table/data-table";

const AggregatorAlertCases = () => {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [blockInput, setBlockInput] = useState<boolean>(true);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) !== -1) {
      setBlockInput(false);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  return <div className="aggregatorAlertCases">
    <DataTable
      style="compact"
      defaultSortCol="creation_date"
      defaultSortDirection="desc"
      columns={[{
        key: "name",
        displayName: "Title",
        dataType: {
          type: "text"
        }
      },{
        key: "creation_date",
        displayName: "Creation date",
        dataType: {
          type: "dateTime"
        }
      }, {
        key: "last_changed_by_name",
        displayName: "Last changed by",
        dataType: {
          type: "text"
        }
      },
      {
        key: "created_by_name",
        displayName: "Created by",
        sortable: false,
        dataType: {
          type: "text"
        } 
      }
    ]}
      dataUrl={{
        url: "aggregator_alertcases",
        backend: "manager"
      }}
      selectionMode="off"
      navigate_to={blockInput ? undefined : "/manager/aggregator_alertcases/new"}
      onBeforeRowClick={async (rowId: string) => {
        navigate(`/manager/aggregator_alertcases/${rowId}`);
        return true; 
      }}
    />
  </div>;
};

export default AggregatorAlertCases;